//To be updated when majoy changes published or differenciation of deployment version needs to be verified from frontend
export const version = "0.82";
